module.exports = __webpack_public_path__ + "img/appstore-download-dark.cf7dd102.svg";